import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { UserData } from "../model/user";
import { CenteredRow, Grid } from "../layout/Row";
import { SmallLogoWithDashboard } from "../logo/SmallLogo";
import LogoutWidget from "../logout/LogoutWidget";
import NotificationOverlay from "../status/NotificationOverlay";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ColumnCentered } from "../layout/Column";

const BatteryStatus = (props: Props) => {
    //@ts-ignore
    const organisationId: string | undefined = props.match.params.organisationId;
    const { userData, user, jwtToken } = props;
    return (
        <div className={"Widget-small-item"}>
            {user && jwtToken && userData ? (
                <>
                    {user && <h3 className={"Widget-title"}>Battery analytics</h3>}
                    <p className={"Widget-description"}>Graphing out the battery percentage of devices over time</p>
                    <Link className={"Dashboard-no-decoration"} to={`/analytics/organisation/${organisationId}/battery`}>
                        <p className={"Dashboard-clickable-text"}>Check out</p>
                    </Link>
                </>
            ) : (
                <></>
            )}
        </div>
    );
};

const ProcessingAndResponseTimes = (props: Props) => {
    //@ts-ignore
    const organisationId: string | undefined = props.match.params.organisationId;
    const { userData, user, jwtToken } = props;
    return (
        <div className={"Widget-small-item"}>
            {user && jwtToken && userData ? (
                <>
                    {user && <h3 className={"Widget-title"}>Processing Analytics</h3>}
                    <p className={"Widget-description"}>Graphing out the response time and processing speed over time</p>
                    <Link className={"Dashboard-no-decoration"} to={`/analytics/organisation/${organisationId}/responseProcessingAnalytics`}>
                        <p className={"Dashboard-clickable-text"}>Check out</p>
                    </Link>
                </>
            ) : (
                <></>
            )}
        </div>
    );
};

const DeviceMetricsForOrganisation = (props: Props) => {
    //@ts-ignore
    const organisationId: string | undefined = props.match.params.organisationId;
    return (
        <div className="Dashboard">
            <div className={"Dashboard-header"}>
                <SmallLogoWithDashboard fontSizeRem={1.625} />
                <LogoutWidget {...props} />
            </div>
            <NotificationOverlay />
            <CenteredRow style={{ paddingBottom: "2.5rem" }}>
                <h1>Metrics for organisation {organisationId}</h1>
            </CenteredRow>
            <Grid style={{ marginBottom: "5rem", marginLeft: "5rem", marginRight: "1rem" }}>
                <BatteryStatus {...props} />
                <ProcessingAndResponseTimes {...props} />
            </Grid>
        </div>
    )
}

const mapStateToProps = (state: any): StateToProps => ({
    jwtToken: state.login.jwtToken,
    user: state.login.user,
    userData: state.login.userData,
});

const mapDispatchToProps: DispatchFromProps = {
    setUser: (_: firebase.User | undefined) => { },
    setUserData: (_: UserData | undefined) => { },
};

export default connect<StateToProps, DispatchFromProps>(
    // @ts-ignore
    mapStateToProps,
    mapDispatchToProps
)(DeviceMetricsForOrganisation);

interface StateToProps {
    jwtToken: string | undefined;
    user: firebase.User | undefined;
    userData: UserData | undefined;
}

interface DispatchFromProps {
    setUser: (_: firebase.User | undefined) => void;
    setUserData: (_: UserData | undefined) => void;
}

interface Props extends StateToProps, DispatchFromProps { }
